function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import Immutable from 'seamless-immutable';
import { RESET_CUSTOMER_RECOVERABLE } from '../actions/customer.actions';
import { SORT_FIELD_NAME, USAGE_SORT_DIRECTION, USAGE_SORT_FIELD } from '../../components/customer/servicesAndUsage/usageDetails/usage.details.table.constants';
import { EMPTY_OBJECT, EMPTY_ARRAY } from '../constants/common.constants';
import { RESET_SEARCH_ENTITLEMENTS_FILTERS, CLEAR_USAGE_DETAILS_RECOVERABLE_UI_STATE, SEARCH_USAGE_DETAILS_ENTITLEMENT_NAME, SET_SELECTED_CALL_CATEGORIES, UPDATE_USAGE_DETAILS_CURRENCY_CODE, UPDATE_USAGE_DETAILS_PAGINATION_DATA, UPDATE_USAGE_DETAILS_SORT, UPDATE_USAGE_DETAILS_SUB_EVENT_FILTER, UPDATE_USAGE_DETAILS_TOTAL_AMOUNT, UPDATE_USAGE_DETAILS_TYPE_DATE_FILTER, UPDATE_USAGE_DETAILS_TYPE_NETWORK_FILTER, UPDATE_USAGE_SEARCH_ENTITLEMENTS_DATEPICKER, UPDATE_USAGE_SEARCH_INCLUDE_EXPIRED, UPDATE_USAGE_SELECTED_ENTITLEMENT_DETAILS } from '../actions/usage.details.actions';
export var INITIAL_STATE = Immutable({
  currencyCode: null,
  callCategories: null,
  endDate: null,
  eventSubTypeFilter: EMPTY_ARRAY,
  entitlementName: null,
  networkTypeFilter: EMPTY_ARRAY,
  paginationData: {
    pageNumber: 1,
    pageSize: 0
  },
  searchEntitlementsDatePicker: {
    shortcut: null,
    startDate: null,
    endDate: null
  },
  includeExpiredEntitlements: false,
  selectedEntitlementDetails: EMPTY_OBJECT,
  sortParams: {
    sortBy: USAGE_SORT_FIELD[SORT_FIELD_NAME.DATE],
    sortDirection: USAGE_SORT_DIRECTION.DESCENDING
  },
  startDate: null,
  totalAmount: 0
});
var searchEntitlementsDatePicker = INITIAL_STATE.searchEntitlementsDatePicker,
  includeExpiredEntitlements = INITIAL_STATE.includeExpiredEntitlements,
  otherInitialStateProps = _objectWithoutProperties(INITIAL_STATE, ["searchEntitlementsDatePicker", "includeExpiredEntitlements"]);
export default function usageDetailsReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
  var _ref = arguments.length > 1 ? arguments[1] : undefined,
    _ref$payload = _ref.payload,
    payload = _ref$payload === void 0 ? {} : _ref$payload,
    type = _ref.type;
  switch (type) {
    case UPDATE_USAGE_DETAILS_TYPE_NETWORK_FILTER:
      return state.set('networkTypeFilter', payload);
    case UPDATE_USAGE_DETAILS_SUB_EVENT_FILTER:
      return state.set('eventSubTypeFilter', payload);
    case UPDATE_USAGE_DETAILS_TYPE_DATE_FILTER:
      return state.set('startDate', payload.startDate).set('endDate', payload.endDate);
    case UPDATE_USAGE_DETAILS_CURRENCY_CODE:
      return state.set('currencyCode', payload);
    case UPDATE_USAGE_DETAILS_TOTAL_AMOUNT:
      return state.set('totalAmount', payload);
    case UPDATE_USAGE_DETAILS_PAGINATION_DATA:
      return state.set('paginationData', payload);
    case UPDATE_USAGE_DETAILS_SORT:
      return state.set('sortParams', payload);
    case UPDATE_USAGE_SEARCH_ENTITLEMENTS_DATEPICKER:
      return state.set('searchEntitlementsDatePicker', payload);
    case UPDATE_USAGE_SEARCH_INCLUDE_EXPIRED:
      return state.set('includeExpiredEntitlements', payload);
    case UPDATE_USAGE_SELECTED_ENTITLEMENT_DETAILS:
      return state.set('selectedEntitlementDetails', payload);
    case SET_SELECTED_CALL_CATEGORIES:
      return state.set('callCategories', payload);
    case SEARCH_USAGE_DETAILS_ENTITLEMENT_NAME:
      return state.set('entitlementName', payload);
    case CLEAR_USAGE_DETAILS_RECOVERABLE_UI_STATE:
    case RESET_CUSTOMER_RECOVERABLE:
      return state.merge(_objectSpread({}, otherInitialStateProps));
    case RESET_SEARCH_ENTITLEMENTS_FILTERS:
      return state.merge({
        searchEntitlementsDatePicker: searchEntitlementsDatePicker,
        includeExpiredEntitlements: includeExpiredEntitlements
      });
    default:
      return state;
  }
}